import React from 'react';
import PropTypes from 'prop-types';
import { FloatingLabelInput as Input } from '../../../../Elements';
import styles from '../../Form.scss';

const TextWidget = ({ placeholder }) => (
  <div className={styles.responseField}>
    <Input name='textInput' placeholder={placeholder || 'Short answer text'} disabled />
  </div>
);

TextWidget.propTypes = {
  editing: PropTypes.bool,
  placeholder: PropTypes.string
};

export default TextWidget;



// WEBPACK FOOTER //
// ./webpack/components/Document/Form/Builder/Widgets/Text.js